import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';


export class VariantesView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            etiquetaCore: {},
            calibres: [],
            cajasPorPaleta: [],
            paises: [],
        };
        var rawUrl = window.location.toString();
        var etiquetaCore_Id = rawUrl.split("EtiquetasCore/")[1].split("/")[0];
        if (props.data) {
            this.state.model = props.data
        }
        else {
            this.state.model = {
                etiquetaCore_Id, calibre_Id: 0, cajasPorPaleta_Id: 0, pais_Id: 0, retailVariantId: "", nombre: "", description: "",
                certificazione: "",
                cat: "",
                confezione: "",
                volume: "",
                particolarita: "",
                varieta: "",
            };
        }
        this.state.modelValidation = {
            calibre_Id: this.state.model.calibre_Id != 0,
            cajasPorPaleta_Id: this.state.model.cajasPorPaleta_Id != 0,
            pais_Id: this.state.model.pais_Id != "",
            retailVariantId: this.state.model.retailVariantId != "",
            nombre: this.state.model.nombre != "",
            description: this.state.model.description != "",
        }
        this.load_etiquetaCore = this.load_etiquetaCore.bind(this);
        this.load_calibres = this.load_calibres.bind(this);
        this.load_cajasPorPaleta = this.load_cajasPorPaleta.bind(this);
        this.load_paises = this.load_paises.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000)
    }
    componentDidMount() {
        this.populateData();
    }
    
    handleChange(event) {

        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        this.setState({
            model: tempModel
        }, () => {
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });

    }
    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/variantes/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }

    render() {
        return (
            <div >
                <Row>
                    <Form>
                        <i><h3 className="pb-2" >General</h3></i>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="producto">
                                        <FormattedMessage id='Producto' />
                                    </Label>
                                    <Input
                                        id="producto"
                                        name="producto"
                                        type="text"
                                        disabled
                                        value={this.state.model.producto}
                                    />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="etiquetaCore">
                                        <FormattedMessage id='EtiquetaCore' />
                                    </Label>
                                    <Input
                                        id="etiquetaCore"
                                        name="etiquetaCore"
                                        type="text"
                                        disabled
                                        value={this.state.model.etiquetaCore}
                                    />
                                </FormGroup>
                            </Col>
                            <Col>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="calibre_Id">
                                        <FormattedMessage id='Calibre' />
                                    </Label>
                                    <Input
                                        id="calibre_Id"
                                        name="calibre_Id"
                                        type="select"
                                        onChange={this.handleChange}
                                        valid={this.getValidationValue(this.state.modelValidation.calibre_Id)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.calibre_Id)}
                                    >
                                        <option value="0"></option>
                                        {this.state.calibres.map(calibre => calibre.calibre_Id == this.state.model.calibre_Id ? (
                                            <option value={calibre.calibre_Id} selected>
                                                {calibre.calibre}
                                            </option>
                                        ) : (<option value={calibre.calibre_Id}>{calibre.calibre}</option>))}
                                    </Input>
                                    <FormFeedback>
                                        {this.state.model.calibre_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="cajasPorPaleta_Id">
                                        <FormattedMessage id='CajasPorPaleta' />
                                    </Label>
                                    <Input
                                        id="cajasPorPaleta_Id"
                                        name="cajasPorPaleta_Id"
                                        type="select"
                                        onChange={this.handleChange}
                                        valid={this.getValidationValue(this.state.modelValidation.cajasPorPaleta_Id)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.cajasPorPaleta_Id)}
                                    >
                                        <option value="0"></option>
                                        {this.state.cajasPorPaleta.map(cajasPorPaleta => cajasPorPaleta.cajasPorPaleta_Id == this.state.model.cajasPorPaleta_Id ? (
                                            <option value={cajasPorPaleta.cajasPorPaleta_Id} selected>
                                                {cajasPorPaleta.cantidad}
                                            </option>
                                        ) : (<option value={cajasPorPaleta.cajasPorPaleta_Id}>{cajasPorPaleta.cantidad}</option>))}
                                    </Input>
                                    <FormFeedback>
                                        {this.state.model.cajasPorPaleta_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="pais_Id">
                                        <FormattedMessage id='Pais' />
                                    </Label>
                                    <Input
                                        id="pais_Id"
                                        name="pais_Id"
                                        type="select"
                                        onChange={this.handleChange}
                                        valid={this.getValidationValue(this.state.modelValidation.pais_Id)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.pais_Id)}
                                    >
                                        <option value="0"></option>
                                        {this.state.paises.map(pais => pais.pais_Id == this.state.model.pais_Id ? (
                                            <option value={pais.pais_Id} selected>
                                                {pais.nombre}
                                            </option>
                                        ) : (<option value={pais.pais_Id}>{pais.nombre}</option>))}
                                    </Input>
                                    <FormFeedback>
                                        {this.state.model.pais_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                        
                        
                        
                        <i><h3 className="pb-2" >Varianti</h3></i>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="retailVariantId">
                                        <FormattedMessage id='RetailVariantId' />
                                    </Label>
                                    <Input
                                        id="retailVariantId"
                                        name="retailVariantId"
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.model.retailVariantId}
                                        valid={this.getValidationValue(this.state.modelValidation.retailVariantId)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.retailVariantId)}
                                    />
                                    <FormFeedback>
                                        {this.state.model.retailVariantId == "" ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="nombre">
                                        <FormattedMessage id='VariantName' />
                                    </Label>
                                    <Input
                                        id="nombre"
                                        name="nombre"
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.model.nombre}
                                        valid={this.getValidationValue(this.state.modelValidation.nombre)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.nombre)}
                                    />
                                    <FormFeedback>
                                        {this.state.model.nombre == "" ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="descripcion">
                                        <FormattedMessage id='VariantDescription' />
                                    </Label>
                                    <Input
                                        id="descripcion"
                                        name="descripcion"
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.model.descripcion}
                                        valid={this.getValidationValue(this.state.modelValidation.descripcion)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.descripcion)}
                                    />
                                    <FormFeedback>
                                        {this.state.model.descripcion == "" ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="certificazione">
                                        <FormattedMessage id='Certificazione' />
                                    </Label>
                                    <Input
                                        id="certificazione"
                                        name="certificazione"
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.model.certificazione}
                                        valid={this.getValidationValue(this.state.modelValidation.certificazione)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.certificazione)}
                                    />
                                    <FormFeedback>
                                        {this.state.model.certificazione === "" ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="cat">
                                        <FormattedMessage id='Cat' />
                                    </Label>
                                    <Input
                                        id="cat"
                                        name="cat"
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.model.cat}
                                        valid={this.getValidationValue(this.state.modelValidation.cat)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.cat)}
                                    />
                                    <FormFeedback>
                                        {this.state.model.cat === "" ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="confezione">
                                        <FormattedMessage id='Confezione' />
                                    </Label>
                                    <Input
                                        id="confezione"
                                        name="confezione"
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.model.confezione}
                                        valid={this.getValidationValue(this.state.modelValidation.confezione)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.confezione)}
                                    />
                                    <FormFeedback>
                                        {this.state.model.confezione === "" ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="volume">
                                        <FormattedMessage id='Volume' />
                                    </Label>
                                    <Input
                                        id="volume"
                                        name="volume"
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.model.volume}
                                        valid={this.getValidationValue(this.state.modelValidation.volume)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.volume)}
                                    />
                                    <FormFeedback>
                                        {this.state.model.volume === "" ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="particolarita">
                                        <FormattedMessage id='Particolarita' />
                                    </Label>
                                    <Input
                                        id="particolarita"
                                        name="particolarita"
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.model.particolarita}
                                        valid={this.getValidationValue(this.state.modelValidation.particolarita)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.particolarita)}
                                    />
                                    <FormFeedback>
                                        {this.state.model.particolarita === "" ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="varieta">
                                        <FormattedMessage id='Varieta' />
                                    </Label>
                                    <Input
                                        id="varieta"
                                        name="varieta"
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.model.varieta}
                                        valid={this.getValidationValue(this.state.modelValidation.varieta)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.varieta)}
                                    />
                                    <FormFeedback>
                                        {this.state.model.varieta === "" ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                        
                       
                       
                    </Form>
                </Row>
            </div>
        );
    }
    async populateData() {
        this.setState({ loading: true, etiquetaCore: await this.load_etiquetaCore() }, async () => {
            this.setState({ calibres: await this.load_calibres(), cajasPorPaleta: await this.load_cajasPorPaleta(), paises: await this.load_paises() },
                async () => {
                }
            );
        });
        

    }
    async load_etiquetaCore() {
        var rawUrl = window.location.toString();
        var etiquetaCore_Id = rawUrl.split("EtiquetasCore/")[1].split("/")[0];
        const token = await authService.getAccessToken();
        const response = await fetch('api/etiquetasCore/' + etiquetaCore_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_calibres() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/calibres?producto_Id=' + this.state.etiquetaCore.producto_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_cajasPorPaleta() {
        const token = await authService.getAccessToken();
        console.log("this.state.etiquetaCore", this.state.etiquetaCore);
        const response = await fetch('api/cajasPorPaleta?producto_Id=' + this.state.etiquetaCore.producto_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_paises() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/paises/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
}